import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";

const NAV_ITEMS = [
  { to: "/admin", label: "Produk", icon: "📦" },
  { to: "/admin/led-products", label: "Produk LED", icon: "🖥️" },
  { to: "/admin/catalog", label: "Kategori, Brand & Tipe", icon: "🏷️" },
  { to: "/admin/settings", label: "Pengaturan Tampilan", icon: "🎨" },
  { to: "/admin/users", label: "Kelola User", icon: "👤" },
];

export default function AdminLayout() {
  const { user, signOut } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div style={{ display: "flex", height: "100vh", background: "#f1f5f9", fontFamily: "system-ui,sans-serif" }}>
      {/* SIDEBAR */}
      <div style={{
        width: 220, background: "#ffffff", borderRight: "1px solid #e2e8f0",
        display: "flex", flexDirection: "column", flexShrink: 0,
      }}>
        <div style={{ padding: "20px 18px", borderBottom: "1px solid #f1f5f9" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#0f172a" }}>RoomDesigner</div>
          <div style={{ fontSize: 11, color: "#94a3b8" }}>Admin Panel</div>
        </div>

        <div style={{ flex: 1, padding: "12px 10px" }}>
          {NAV_ITEMS.map((item) => {
            const active = location.pathname === item.to;
            return (
              <Link
                key={item.to}
                to={item.to}
                style={{
                  display: "flex", alignItems: "center", gap: 8,
                  padding: "9px 12px", borderRadius: 8, marginBottom: 4,
                  fontSize: 13, fontWeight: 600, textDecoration: "none",
                  color: active ? "#1d4ed8" : "#475569",
                  background: active ? "#eff6ff" : "transparent",
                }}
              >
                <span>{item.icon}</span> {item.label}
              </Link>
            );
          })}
        </div>

        <div style={{ padding: "12px 14px", borderTop: "1px solid #f1f5f9" }}>
          <div style={{ fontSize: 11, color: "#94a3b8", marginBottom: 8, wordBreak: "break-all" }}>
            {user?.email}
          </div>
          <button
            onClick={handleLogout}
            style={{
              width: "100%", padding: "8px", borderRadius: 8, fontSize: 12, fontWeight: 600,
              border: "1px solid #fecaca", background: "#fef2f2", color: "#dc2626", cursor: "pointer",
            }}
          >
            Keluar
          </button>
          <Link
            to="/"
            style={{
              display: "block", textAlign: "center", marginTop: 8,
              fontSize: 11, color: "#94a3b8", textDecoration: "underline",
            }}
          >
            ← Kembali ke RoomDesigner
          </Link>
        </div>
      </div>

      {/* CONTENT */}
      <div style={{ flex: 1, overflow: "auto" }}>
        <Outlet />
      </div>
    </div>
  );
}